import React from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFacebookF, faLinkedin} from '@fortawesome/free-brands-svg-icons';
import {Col, Container, Row} from "reactstrap";

const KOREM_CANADA_LOCATION_LINK = "https://www.google.com/maps/place/Korem/@46.812042,-71.2261794,17z/data=!3m1!4b1!4m5!3m4!1s0x4cb89674745ad215:0x23e39aa14d786dfa!8m2!3d46.812042!4d-71.2239907";
const KOREM_USA_LOCATION_LINK = "https://www.google.com/maps/place/8400+E+Crescent+Pkwy+%23652,+Greenwood+Village,+CO+80111,+%C3%89tats-Unis/@39.6223224,-104.8912991,17z/data=!3m1!4b1!4m5!3m4!1s0x876c8656ffea859b:0x288efba4abf675bd!8m2!3d39.6223224!4d-104.8891104";
const KOREM_TELEPHONE_NUMBER = "1 888 440-1627";
const KOREM_EMAIL = "info@korem.com";
const KOREM_FACEBOOK = "https://www.facebook.com/korem.geospatial/";
const KOREM_LINKED_IN = "https://www.linkedin.com/company/korem/";

const Footer = () =>
    <Container className="footer">
        <Row style={{marginLeft: "0px", marginRight: "0px"}} >
            <Col><b>Korem USA</b></Col>
            <Col><b>Korem Canada</b></Col>
            <Col><b>Connect with us</b></Col>
        </Row>
        <Row style={{marginLeft: "0px", marginRight: "0px"}}>
            <Col>
                <a
                    href={KOREM_USA_LOCATION_LINK}
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    8400 E Crescent Pkwy, Suite 652
                    Greenwood Village, Colorado 80111
                </a>
            </Col>
            <Col>
                <a
                    href={KOREM_CANADA_LOCATION_LINK}
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    330 St. Vallier Street East, Suite 240 Quebec, QC G1K 9C5
                </a>
            </Col>
            <Col>
                <a href={`tel:${KOREM_TELEPHONE_NUMBER}`} rel="noopener noreferrer" target="_blank">{KOREM_TELEPHONE_NUMBER}</a>
                <br/>
                <a href={`mailto:${KOREM_EMAIL}`} rel="noopener noreferrer" target="_blank">{KOREM_EMAIL}</a> <br/>
                <a href={KOREM_FACEBOOK} rel="noopener noreferrer" target="_blank"><FontAwesomeIcon icon={faFacebookF}/></a> {' '}
                <a href={KOREM_LINKED_IN} rel="noopener noreferrer" target="_blank"><FontAwesomeIcon icon={faLinkedin}/></a>
            </Col>
        </Row>
    </Container>;

export default Footer;
